export default {
  categories: [],
  list: [],
  loaded: false,
  selected: 0
};
